import React, { useState, useEffect } from 'react'
import { Input, Button, Card, Modal, Form, message, Row, Col, Table } from 'antd'
import _ from 'lodash'
import { paginationInit, formatMessage } from '../../utils/common'
import { modalConfirm, modalError } from '../../utils/modalUtils'
import { getANTTemplateList, modifyANTTemplate, deleteANTTemplate } from '../../services/configuration/config'
import { PlusOutlined, CloseOutlined } from '@ant-design/icons'
import AntdTable from '../../components/table/AntdTable'
import { useSelector } from 'react-redux'
import { hasPermission } from '@/annotations/nike-react'
const menu_nfc_configuration_antTemplate = 'menu_nfc_configuration_antTemplate'
const initFieldList = [
  { sequenceId: 1, sequenceName: '' },
  { sequenceId: 2, sequenceName: '' },
  { sequenceId: 3, sequenceName: '' },
  { sequenceId: 4, sequenceName: '' },
  { sequenceId: 5, sequenceName: '' },
  { sequenceId: 6, sequenceName: '' }
]

const ANTTemplate = () => {
  const commonStore = useSelector(state => state.commonStore)
  const [modalForm] = Form.useForm()
  const [tableList, setTableList] = useState([])
  const [queryFlag, setQueryFlag] = useState(false)
  const [pagination, setPagination] = useState(paginationInit)
  const [modalVisible, setModalVisible] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [fieldList, setFieldList] = useState(initFieldList)
  const [editItem, setEditItem] = useState({})
  const [checkItem, setCheckItem] = useState(null)
  const [checkTamplateName, setCheckTamplateName] = useState('')
  const [tableHeight, setTableHeight] = useState(0)

  const tableColumnsView = [
    {
      title: formatMessage(commonStore, 'languageObj.configuration.templateName'),
      dataIndex: 'template',
      render: (text, record) => (
        <span className="link_name" onClick={() => onCheck(record)}>
          {text}
        </span>
      )
    },
    {
      title: formatMessage(commonStore, 'languageObj.configuration.templateDescription'),
      dataIndex: 'description'
    }
  ]
  const tableColumnsOpt = [
    {
      title: formatMessage(commonStore, 'languageObj.configuration.action'),
      dataIndex: 'action',
      render: (text, record) => {
        return (
          <div>
            <span className="link_name" style={{ marginRight: 50 }} onClick={() => onEdit(record)}>
              {formatMessage(commonStore, 'languageObj.commonLocale.edit')}
            </span>
            <span className="link_name" onClick={() => onDelete(record)}>
              {formatMessage(commonStore, 'languageObj.commonLocale.delete')}
            </span>
          </div>
        )
      }
    }
  ]
  let tableColumns = tableColumnsView
  if (hasPermission(menu_nfc_configuration_antTemplate)) {
    tableColumns = tableColumns.concat(tableColumnsOpt)
  }

  useEffect(() => {
    const ele = document.getElementsByClassName('main-container')[0]
    const height = ele.offsetHeight - 250
    setTableHeight(height)
  }, [])

  useEffect(() => {
    searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])

  const searchDataFun = () => {
    const params = {
      pageNo: pagination.currentPage,
      size: pagination.pageSize
    }
    getANTTemplateList(params).then(res => {
      const dt = res.resultData
      const pg = { ...pagination, total: dt.total }
      setTableList(dt.records)
      setPagination(pg)
    })
  }

  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }

  const handleUserOk = () => {
    const params = modalForm.getFieldsValue()
    const hasFiledNameList = fieldList.filter(item => item.sequenceName)
    if (!params.template) {
      modalError({ content: formatMessage(commonStore, 'languageObj.configuration.templateNameError') })
      return
    }
    if (hasFiledNameList.length <= 0) {
      modalError({ content: formatMessage(commonStore, 'languageObj.configuration.fieldListError') })
      return
    }
    if (isEdit) params.id = editItem.id
    params.itemList = fieldList
    modifyANTTemplate(params)
      .then(res => {
        if (!res || res.errorCode !== '200') return
        message.success(formatMessage(commonStore, 'languageObj.commonLocale.success'))
        setQueryFlag(!queryFlag)
        resetStatus()
      })
      .catch(error => {
        resetStatus()
        let str = ''
        if (error && error.errorCode === '2010') {
          str = formatMessage(commonStore, 'languageObj.configuration.addTemplateError')
        } else if (error && error.errorCode === '2011') {
          str = formatMessage(commonStore, 'languageObj.configuration.addTemplateError2')
        } else {
          str = formatMessage(commonStore, 'languageObj.httpLocale.requestError')
        }
        modalError({ content: str })
      })
  }

  const resetStatus = () => {
    modalForm.resetFields()
    setModalVisible(false)
    setIsEdit(false)
    setFieldList(initFieldList)
  }

  const onFieldNameChange = (e, index) => {
    const list = _.cloneDeep(fieldList)
    list[index].sequenceName = e.target.value
    setFieldList(list)
  }

  const onEdit = record => {
    setIsEdit(true)
    setModalVisible(true)
    setEditItem(record)

    const ele = document.getElementById('test')
    setTimeout(() => {
      ele.scrollIntoView(false)
    }, 100)
    const { template, description, items } = record
    modalForm.setFieldsValue({ template, desc: description })
    const list = getList(items)
    if (items && items.length > 0) setFieldList(list)
  }

  const onDelete = record => {
    modalConfirm(
      {
        content: formatMessage(commonStore, 'languageObj.configuration.deleteDataTip')
      },
      () => {
        deleteANTTemplate({ templateName: record.template }).then(res => {
          if (res.errorCode !== '200') return
          message.success(formatMessage(commonStore, 'languageObj.commonLocale.success'))
          const { currentPage, pageSize, total } = pagination
          const nextPage = Math.ceil((total - 1) / pageSize)
          if (nextPage > 0 && nextPage < currentPage) {
            setPagination({ ...pagination, currentPage: nextPage })
          }
          setQueryFlag(!queryFlag)
          if (record.template === checkTamplateName) onCloseCheck()
        })
      }
    )
  }

  const onCheck = record => {
    const list = getList(record.items)
    setCheckItem(list)
    setCheckTamplateName(record.template)
  }

  const onCloseCheck = () => {
    setCheckItem(null)
    setCheckTamplateName('')
  }

  const getList = items => {
    const obj = {}
    items.forEach((item, index) => {
      obj[item.sequenceId] = { id: item.id, sequenceName: item.sequenceName }
    })
    const list = initFieldList.map(item => {
      if (!obj[item.sequenceId]) return item
      return {
        ...item,
        id: obj[item.sequenceId].id,
        sequenceName: obj[item.sequenceId].sequenceName
      }
    })
    return list
  }

  return (
    <div id="test">
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        {hasPermission(menu_nfc_configuration_antTemplate) ? (
          <Button
            type="primary"
            style={{ marginLeft: '16px', marginTop: '10px' }}
            onClick={() => {
              resetStatus()
              setModalVisible(true)
            }}
          >
            <PlusOutlined />
            {formatMessage(commonStore, 'languageObj.configuration.addTemplate')}
          </Button>
        ) : null}
        <Row>
          <Col span={checkItem && checkItem.length > 0 ? 16 : 24}>
            <div className="content-container" style={{ flex: 1 }}>
              <AntdTable
                rowKey={record => record.id}
                dataSource={tableList}
                columns={tableColumns}
                pagination={pagination}
                onChange={handleTableChange}
                scroll={{ y: tableHeight }}
              />
            </div>
          </Col>
          {checkItem && checkItem.length > 0 && (
            <Col span={8}>
              <Card
                size="small"
                title={`${checkTamplateName} - ${formatMessage(commonStore, 'languageObj.nfcScanLocale.fieldInfo')}`}
                style={{ margin: 16 }}
                bodyStyle={{ padding: 4 }}
                extra={
                  <Button type="text" onClick={onCloseCheck}>
                    <CloseOutlined />
                  </Button>
                }
              >
                <Table
                  size="small"
                  bordered
                  columns={[
                    { title: formatMessage(commonStore, 'languageObj.configuration.fieldId'), dataIndex: 'sequenceId' },
                    {
                      title: formatMessage(commonStore, 'languageObj.configuration.fieldName'),
                      dataIndex: 'sequenceName'
                    }
                  ]}
                  dataSource={checkItem}
                  pagination={false}
                />
              </Card>
            </Col>
          )}
        </Row>
      </Card>

      <Modal
        open={modalVisible}
        maskClosable={false}
        className="nike_modal"
        width={620}
        title={
          isEdit
            ? formatMessage(commonStore, 'languageObj.configuration.editTemplate')
            : formatMessage(commonStore, 'languageObj.configuration.addTemplate')
        }
        onOk={handleUserOk}
        onCancel={resetStatus}
        destroyOnClose
      >
        <Form
          name="basic"
          form={modalForm}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          initialValues={{}}
          autoComplete="off"
        >
          <Form.Item
            label={formatMessage(commonStore, 'languageObj.configuration.templateName')}
            name="template"
            required
          >
            <Input disabled={isEdit} />
          </Form.Item>
          <Form.Item label={formatMessage(commonStore, 'languageObj.configuration.templateDescription')} name="desc">
            <Input />
          </Form.Item>
          <Card>
            <Row style={{ fontWeight: 'bold' }}>
              <Col span={4}>{formatMessage(commonStore, 'languageObj.configuration.fieldId')}</Col>
              <Col span={20}>{formatMessage(commonStore, 'languageObj.configuration.fieldName')}</Col>
            </Row>
            {fieldList.map((item, index) => {
              return (
                <Row key={index} align="middle" style={{ paddingTop: 16 }}>
                  <Col span={4}>
                    <span>{item.sequenceId}</span>
                  </Col>
                  <Col span={20}>
                    <Input value={item.sequenceName} onChange={e => onFieldNameChange(e, index)} />
                  </Col>
                </Row>
              )
            })}
          </Card>
        </Form>
      </Modal>
    </div>
  )
}
export default ANTTemplate
